
const RACES = [
  {
    id: "angile",
    name: "Angile",
    description: "Tall, lithe beings with magnificent feathered wings and midnight-dark skin. Seemingly eternal, they grow additional wing sets each millennium. Their culture promotes long-lasting stability and the natural world above all individuals.",
    stats: { might: 7, speed: 6, intellect: 7, magic: 10 },
    movement: 5,
    perks: ["Intimidate", "Fire Magic", "Healing Magic"],
    abilities: [
      { name: "Fly", desc: "Movement is not restricted to ground. Spend a D4 of Current Speed per successful flight." },
      { name: "Regenerate Magic", desc: "Restore Current Magic outside of combat. Regain up to your Magic Power number in D4s per day." },
      { name: "Commune with Objects", desc: "A unique Magic School used to talk to objects and learn about their past experiences." },
    ],
  },
  {
    id: "avice",
    name: "Avice",
    description: "Community-minded desert dwellers with malleable, glowing bodies. Supported by sturdy cartilage instead of bones, they possess remarkable flexibility and the ability to heal others without Magic or Alchemy.",
    stats: { might: 8, speed: 7, intellect: 8, magic: 7 },
    movement: 5,
    perks: ["Constitution", "Sleight of Hand", "Perception"],
    abilities: [
      { name: "Touch of Life", desc: "Spend 1 Health Point to give another character, on contact, 3 Health Points of the same Stat." },
      { name: "Morf", desc: "Spend a D4 of Current Speed to squeeze through any opening that is no smaller than their head." },
      { name: "Illumination", desc: "Give off a pink tinted glow at will, making dark areas easier to traverse." },
    ],
  },
  {
    id: "bathla",
    name: "Bathla",
    description: "A naturally aquatic race with razor-sharp fins and intuitive Water Magic mastery. Peerless swimmers and terrifyingly adept duelists, they inhabit waters across the globe — possibly more numerous than all other races combined.",
    stats: { might: 6, speed: 10, intellect: 6, magic: 8 },
    movement: 6,
    perks: ["Recover", "Dodge", "Water Magic"],
    abilities: [
      { name: "Natural Blades", desc: "Permanent weapons that do not take up a weapon slot. Deal 2D4 damage using the Small Weapons Skill." },
      { name: "Double Strike", desc: "A successful Small Weapons attack deals two instances of damage." },
      { name: "Amphibious", desc: "Suited for survival both underwater and in non-arid land climates. Gain additional 50% movement while in water." },
    ],
  },
  {
    id: "bhantor",
    name: "Bhantor",
    description: "Towering, exceptionally burly beings who covet sheer strength above all else. Leaders are chosen through tournament combat. They possess exponential healing rates that sustain their violent lifestyle and culture of martial supremacy.",
    stats: { might: 13, speed: 7, intellect: 5, magic: 5 },
    movement: 6,
    perks: ["Brawl", "Constitution", "Large Weapons"],
    abilities: [
      { name: "Regeneration", desc: "Restore up to double the character's Might Modifier in D6s of Health Points per day. May regenerate lost limbs over time." },
      { name: "Improvised Weapons", desc: "Effectively use objects as weapons of an appropriate type." },
      { name: "Power Strike", desc: "Spend Current Might to deal extra damage with Might-based attacks. Use 2 Current Might per D4 of damage. Can stack up to Might Modifier in D4s." },
    ],
  },
  {
    id: "cregex",
    name: "Cregex",
    description: "Small reptilian creatures from the planet's crust, adorned with vibrant geode crystals that grow throughout their lifetime. Masters of sustainable crystal cultivation, they reproduce asexually and grow their young similarly to their food.",
    stats: { might: 6, speed: 5, intellect: 10, magic: 9 },
    movement: 4,
    perks: ["Block", "Constitution", "Identify"],
    abilities: [
      { name: "Papermancy", desc: "A unique Magic School that grants the ability to control paper with Magic, changing its form and translating text. Uses D4s for Magic Power." },
      { name: "Geophagy", desc: "Unable to consume regular food — eats rocks to gain back Health Points. Certain minerals can grant various Status Effects." },
      { name: "Natural Armor", desc: "Gain a static 2 AR." },
    ],
  },
  {
    id: "demile",
    name: "Demile",
    description: "The most populous race — descendants of the Angile, but lacking their wings and Magic regeneration. Their culture celebrates comradery and mastering passions. All EXP they earn becomes Universal, making them remarkably versatile.",
    stats: { might: 7, speed: 8, intellect: 7, magic: 8 },
    movement: 5,
    perks: ["Initiative", "Knowledge", "Fire Magic"],
    abilities: [
      { name: "Jack of All Trades", desc: "All weapon Skill Checks gain a D4 added to the roll." },
      { name: "Adaptation", desc: "All EXP earned becomes Universal." },
      { name: "Color Magic", desc: "A unique Magic School that lets the user change the color of objects or characters." },
    ],
  },
  {
    id: "draconid",
    name: "Draconid",
    description: "Descendants of Demile fused with dragon stones through a forbidden Alchemic ritual. Dragon Aspects manifest in them physically. Their unknown potential and blasphemous origins frighten many, leading most to take up dangerous adventuring work.",
    stats: { might: 9, speed: 6, intellect: 6, magic: 9 },
    movement: 6,
    perks: ["Intimidate", "Initiative", "Perception"],
    abilities: [
      { name: "Dragon Aspects (pick 2)", desc: "Choose 2 from: Claws (Piercing Brawl), Eyes (+2 Perception/Identify), Horns (2D4 Brawl + 1 AR), Scales (+2 AR), Talons (+1 Balance/+3 Recover), Tail (Crushing Might Modifier damage, Free Action), Wings (Fly)." },
      { name: "Dragon Breath (pick 1)", desc: "Choose 1: Infernal (inflicts Burn), Sonic (Piercing), or Toxic (inflicts Poison). Leveled like a Magic using 4 EXP. Uses D8s for Magic Power. Costs 2 Magic per die." },
    ],
  },
  {
    id: "enli",
    name: "Enli",
    description: "Serene avian people with long sharp faces and vibrant eyes. Their feathery plumes and razor-sharp talons are always kept pristine. They celebrate debate and diversity, and their home city Cordiva is a pan-religious monument and model of the future.",
    stats: { might: 6, speed: 6, intellect: 10, magic: 8 },
    movement: 5,
    perks: ["Balance", "Identify", "Perception"],
    abilities: [
      { name: "Trader", desc: "Add a D4 to Persuasion Checks." },
      { name: "Talons", desc: "Permanent natural weapons. Choose: Speed Talons (2D4 Piercing, Small Weapons) or Might Talons (2D8 damage, Large Weapons)." },
      { name: "Hypnotize", desc: "A unique Magic School used to influence targets to submit to the wielder's desires. The target must look at the character's third eye. Uses D4s for Magic Power." },
    ],
  },
  {
    id: "feline",
    name: "Feline",
    description: "Swift hunters native to the deep forests of northern Nalssadda. Often stereotyped as naïve due to their reclusive society, but their resourcefulness surprises anyone who underestimates them. They dwell in forests that descend into vast, dangerous valleys.",
    stats: { might: 6, speed: 12, intellect: 7, magic: 5 },
    movement: 6,
    perks: ["Athletics", "Ranged", "Sneak"],
    abilities: [
      { name: "Hunter", desc: "Add a D4 to Intuition Checks." },
      { name: "Jump", desc: "Doubles the height and distance the character can jump. Add a D6 to Balance Checks." },
      { name: "Ambush", desc: "After dealing damage while hidden, player may roll a Sneak Check to stay hidden." },
    ],
  },
  {
    id: "halfling",
    name: "Halfling",
    description: "Short, dexterous spiritualists and adept craftspeople native to eastern Andaloor. Profound in their connection to nature and Alchemy, they build architecture around and with the natural world. Their potion-making abilities are legendary.",
    stats: { might: 5, speed: 6, intellect: 12, magic: 7 },
    movement: 4,
    perks: ["Sleight of Hand", "Intuition", "Illusion Magic"],
    abilities: [
      { name: "Magic Perception", desc: "When making a Perception Check, perceive remnants and sources of magic." },
      { name: "Potion Making", desc: "Created potions can gain additional effects without spending more time or materials; such as regeneration on a healing potion, or Debuff effects on poisons." },
      { name: "Animal Magnetism", desc: "Add a D6 to Animal Magic." },
    ],
  },
  {
    id: "krazeff",
    name: "Krazeff",
    description: "Hardy tundra-dwellers originally from a world of ice and snow. The only race that can reliably manipulate solid water using Magic. Their capitol Ilithia is carved from a massive glacier, showcasing beautifully intricate ice architecture.",
    stats: { might: 6, speed: 8, intellect: 9, magic: 7 },
    movement: 5,
    perks: ["Constitution", "Dodge", "Tech"],
    abilities: [
      { name: "Resist Cold", desc: "Cold damage is reduced by 25%." },
      { name: "Ice Magic", desc: "A unique Magic School which allows users to form and control ice. Uses D4s for Magic Power." },
      { name: "Engineering", desc: "Add a D4 to Craft, Tech, and Sleight of Hand Checks." },
    ],
  },
  {
    id: "rangalese",
    name: "Rangalese",
    description: "Naturalists with bark-like skin and hair that looks as though leaves grow through it. Devoted followers of the deity Zeffratt, they have mastered manipulating the life cycle using 'Necrobotany' — a Magic School with remarkably diverse applications.",
    stats: { might: 6, speed: 6, intellect: 8, magic: 10 },
    movement: 5,
    perks: ["Persuasion", "Animal Magic", "Plant Magic"],
    abilities: [
      { name: "Necrobotany", desc: "A unique Magic School that grants control over dead and rotting organic matter. Uses D4s for Magic Power." },
      { name: "Magic Resistance", desc: "Add a D6 to defensive Checks against all Simple Tier Magic Schools." },
    ],
  },
  {
    id: "rhozen",
    name: "Rhozen",
    description: "An all-female race devoted to an ancient Infernal Dragon. Blessed with physical might and the ability to inflict searing pain on contact. Notorious Alchemists who can create weapons from almost anything, making them nearly impossible to catch unarmed.",
    stats: { might: 10, speed: 7, intellect: 7, magic: 6 },
    movement: 5,
    perks: ["Craft", "Small Weapons", "Earth Magic"],
    abilities: [
      { name: "Pain Touch", desc: "A unique Great Tier Magic School that allows characters to inflict Piercing Magic damage on contact." },
      { name: "Auxiliary Alchemist", desc: "Add 10 to Auxiliary Preparation rolls." },
      { name: "Fire Resistance", desc: "Fire damage is reduced by 25%." },
    ],
  },
  {
    id: "sytarn",
    name: "Sytarn",
    description: "Towering beings with sturdy horns and hoofed feet — the only sentient race that cannot use Magic. They compensate with unmatched craftsmanship, inexplicable luck, and the finest equipment in the world. Their cities burst with brilliant color and intricate design.",
    stats: { might: 13, speed: 8, intellect: 9, magic: 0 },
    movement: 5,
    perks: ["Block", "Craft", "Perception"],
    abilities: [
      { name: "Night Vision", desc: "Exceptional vision in low-light conditions." },
      { name: "Horns", desc: "Deal a D6 of damage using Brawl, and grant 2 AR." },
      { name: "Luck", desc: "Add a D4 to all Skill Checks, excluding Crits." },
    ],
  },
];

export default RACES
